export const BIASHARA_FLEXI_PAYLOAD_COLLECTION = 'digitalSavings/collection/';

// API Calls actions
export const API_PENDING_TRANSITION_PAYLOAD_COLLECTION = `${BIASHARA_FLEXI_PAYLOAD_COLLECTION}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PAYLOAD_COLLECTION = `${BIASHARA_FLEXI_PAYLOAD_COLLECTION}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PAYLOAD_COLLECTION = `${BIASHARA_FLEXI_PAYLOAD_COLLECTION}/apiTransition/failure`;
export const API_PAYMENT_COMPLETE = `${BIASHARA_FLEXI_PAYLOAD_COLLECTION}/apiPaymentInitiation`;

export const apiTransitionPayloadCollection = {
	pending: () => ({
		type: API_PENDING_TRANSITION_PAYLOAD_COLLECTION,
	}),
	success: () => ({
		type: API_SUCCESS_TRANSITION_PAYLOAD_COLLECTION,
	}),
	failure: () => ({
		type: API_FAILURE_TRANSITION_PAYLOAD_COLLECTION,
	}),
};

//calculated Data
export const COLLECT_PAYLOAD_DATA = BIASHARA_FLEXI_PAYLOAD_COLLECTION + 'collectPayloadData';
export const SUBMIT_COLLECT_PAYLOAD_SUCCESS = BIASHARA_FLEXI_PAYLOAD_COLLECTION + 'success';
export const SUBMIT_COLLECT_PAYLOAD_FAILURE = BIASHARA_FLEXI_PAYLOAD_COLLECTION + 'failure';

export const collectPayloadData = (step) => ({
	type: COLLECT_PAYLOAD_DATA,
	step
});
export const submitPayloadDataSuccess = (value) => ({
	type: SUBMIT_COLLECT_PAYLOAD_SUCCESS,
	value,
});
export const submitPayloadDataFailure = (error) => ({
	type: SUBMIT_COLLECT_PAYLOAD_FAILURE,
	error,
});

export const paymentInitiation = (value) => ({
	type: API_PAYMENT_COMPLETE,
	value,
});
